var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrihodiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.09,4.36 12.82,7.63 12.69,0 11.15,0 11.18,7.63 7.91,4.36 6.55,5.61 11.73,10.91 17.29,5.61  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.73,10.91L11.73,10.91H0.82V24h22.37V10.91H11.73z M21.47,19.09c0,0-1.21,0.14-2.18,1.09 c-0.98,0.95-1.09,2.18-1.09,2.18H5.1c0,0,0.19-1.12-0.55-2.18c-0.74-1.06-2.18-1.09-2.18-1.09v-3.27c0,0,1.38-0.13,2.18-1.09 c0.8-0.96,0.55-2.18,0.55-2.18h13.09c0,0,0.23,1.26,1.09,2.18c0.86,0.92,2.18,1.09,2.18,1.09V19.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,14.63c-1.51,0-2.73,1.22-2.73,2.73c0,1.51,1.22,2.73,2.73,2.73c1.51,0,2.73-1.22,2.73-2.73 C14.43,15.85,13.21,14.63,11.7,14.63z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrihodiIcon);
export default __webpack_public_path__ + "static/media/prihodi_icon.9c6d3c89.svg";
export { ForwardRef as ReactComponent };